import { apiRequest } from './axiosConfig';

export type JevChoice = 'a' | 'b' | 'tie' | 'insufficient';

export interface JevComparisonInput {
  criterion: string;
  context: string;
  option_a: string;
  option_b: string;
}

export interface JevComparisonResult {
  choice: JevChoice;
  probabilities: Record<JevChoice, number>;
  confidence: number | null;
  elapsed_ms: number;
  input_tokens: number;
  model: string;
}

export async function evaluateJev(input: JevComparisonInput, signal?: AbortSignal): Promise<JevComparisonResult> {
  const response = await apiRequest.post<{ data: JevComparisonResult }>('jev/evaluate', input, {
    signal,
    timeout: 30000,
  });
  return response.data;
}
